/* 应用管理是一级菜单active不需要为数组 */
const manage_route = [{
    path: '/manage/applist',
    name: "applist",
    component: resolve => {
      require(["@/views/manage/app/AppList.vue"], resolve);
    },
    meta: {
      title: '应用列表',
      navtype: 2,
      id: [10043, 10067],
      active: '/manage/applist'
    }
  },
  {
    path: '/manage/appinfo',
    name: "appinfo",
    component: resolve => {
      require(["@/views/manage/app/AppInfo.vue"], resolve);
    },
    meta: {
      title: '服务应用详情',
      navtype: 2,
      id: [10044],
      active: '/manage/applist'
    }
  },
  // 
  {
    path: '/manage/edgeDetail',
    name: "edgeDetail",
    component: resolve => {
      require(["@/views/manage/app/components/edgeDetail.vue"], resolve);
    },
    meta: {
      title: '边缘计算应用详情',
      navtype: 2,
      id: [10068],
      active: '/manage/applist'
    }
  },
];
export default manage_route